import { Component, EventEmitter, Input, Output } from '@angular/core';
import {  AttachmentDto, AttachmentFileType } from '../attachment';
import * as FileSaver from 'file-saver';
import { CoreTranslationService } from 'src/app/shared/services/translation.service';
import { BaseComponent } from 'src/app/shared/components/component-base';
import { AttachementService } from 'src/app/shared/services/attachement';

@Component({
  selector: 'app-attachment-list',
  templateUrl: './attachment-list.component.html',
  styleUrls: ['./attachment-list.component.css']
})
export class AttachmentListComponent extends BaseComponent {
  @Input() serverDelete: boolean = true;
  @Input() displayFileLanguage: boolean = false;
  @Input() displayDiscription: boolean = true;
  @Input() viewOnly: boolean = false;
  @Input() hideDeleteBtn:boolean= false;
  @Input() ShowCreatedOn: boolean = false;
  @Input() attachments!: AttachmentDto[];
  @Output() onDelete = new EventEmitter<string>();

  constructor(
    private coreTranslationService: CoreTranslationService,
    public override attachementService?: AttachementService,

  ) {
    super();
    
  }
//   ngOnInit(){
// var sss = this.attachments;
// }
  ngAfterViewInit() {
    var ssss = this.attachments;
  }
  deleteAttachment(attachmentId: string){
    let indexOfList = this.attachments.findIndex(
      (a) => a.id == attachmentId
    );
    this.attachments[indexOfList].isDeleted=true;
    if(this.attachments[indexOfList].isNew)
      {
        this.attachments.splice(indexOfList,1);
      }
  this.onDelete.emit(attachmentId);
  }
 

  downloadAttachment(attachment: AttachmentDto) {
    this.attachementService.get(attachment.id).subscribe((result: any) => {
      if (result) {
          const byteCharacters = atob(result.fileContent);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const file = new Blob([byteArray], { type: result.contentType });
          FileSaver.saveAs(file, result.fileName);
      }
  });


}

}
